// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DocumentList-documentUploadListContainer-gNJZp {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 12px;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: justify;
        -ms-flex-pack: justify;
            justify-content: space-between;
    margin-top: 18px;
}

.DocumentList-documentUploadListImgContainer-dcnMD {
    position: relative;
    width: 100%;
    height: 185px;
    border-radius: 4px;
}

.DocumentList-documentUploadListImg-dyE_V {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    -o-object-fit: contain;
       object-fit: contain;
    border-radius: inherit;
}

.DocumentList-documentUploadListRemoveBtnContainer-LK_va {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
    margin-top: 6px;
}

.DocumentList-documentUploadListRemoveBtn-tR2DH,
.DocumentList-documentUploadListRemoveBtn-tR2DH:hover,
.DocumentList-documentUploadListRemoveBtn-tR2DH:focus {
    color: var(--primary-link-foreground);
    cursor: pointer;

}

.DocumentList-documentUploadListRemoveBtn-tR2DH:hover,
.DocumentList-documentUploadListRemoveBtn-tR2DH:focus {
    text-decoration: underline;
}

@media (max-width: 767px) and (min-width: 441px) {
    .DocumentList-documentUploadListContainer-gNJZp {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (max-width: 440px) {
    .DocumentList-documentUploadListContainer-gNJZp {
        grid-template-columns: 100%;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/DocumentList/DocumentList.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,yBAA8B;QAA9B,sBAA8B;YAA9B,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,sBAAmB;OAAnB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;;;IAGI,qCAAqC;IACrC,eAAe;;AAEnB;;AAEA;;IAEI,0BAA0B;AAC9B;;AAEA;IACI;QACI,qCAAqC;IACzC;AACJ;;AAEA;IACI;QACI,2BAA2B;IAC/B;AACJ","sourcesContent":[".documentUploadListContainer {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 12px;\n    align-items: center;\n    justify-content: space-between;\n    margin-top: 18px;\n}\n\n.documentUploadListImgContainer {\n    position: relative;\n    width: 100%;\n    height: 185px;\n    border-radius: 4px;\n}\n\n.documentUploadListImg {\n    position: absolute;\n    inset: 0;\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n    border-radius: inherit;\n}\n\n.documentUploadListRemoveBtnContainer {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-top: 6px;\n}\n\n.documentUploadListRemoveBtn,\n.documentUploadListRemoveBtn:hover,\n.documentUploadListRemoveBtn:focus {\n    color: var(--primary-link-foreground);\n    cursor: pointer;\n\n}\n\n.documentUploadListRemoveBtn:hover,\n.documentUploadListRemoveBtn:focus {\n    text-decoration: underline;\n}\n\n@media (max-width: 767px) and (min-width: 441px) {\n    .documentUploadListContainer {\n        grid-template-columns: repeat(2, 1fr);\n    }\n}\n\n@media (max-width: 440px) {\n    .documentUploadListContainer {\n        grid-template-columns: 100%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"documentUploadListContainer": `DocumentList-documentUploadListContainer-gNJZp`,
	"documentUploadListImgContainer": `DocumentList-documentUploadListImgContainer-dcnMD`,
	"documentUploadListImg": `DocumentList-documentUploadListImg-dyE_V`,
	"documentUploadListRemoveBtnContainer": `DocumentList-documentUploadListRemoveBtnContainer-LK_va`,
	"documentUploadListRemoveBtn": `DocumentList-documentUploadListRemoveBtn-tR2DH`
};
module.exports = ___CSS_LOADER_EXPORT___;
